import { render } from "./InlineVersionPicker.vue?vue&type=template&id=3b08b244&scoped=true"
import script from "./InlineVersionPicker.vue?vue&type=script&lang=js"
export * from "./InlineVersionPicker.vue?vue&type=script&lang=js"

import "./InlineVersionPicker.vue?vue&type=style&index=0&id=3b08b244&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b08b244"]])

export default __exports__